import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'jumpScopePipe'})
export class JumpScopePipe implements PipeTransform {
    transform(value: any[], nodeId: string): any[] {
        return value.filter(item => item.Id !== nodeId);
    }
}
